import { connect } from 'react-redux';

import SubscriptionsView from '../components/SubscriptionsView';

const mapActionCreators = {};

const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    mapActionCreators
)(SubscriptionsView);
